(function(){
'use strict';
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ---------- ripple ---------- */
document.querySelectorAll('.btn').forEach(function(b){
  b.addEventListener('pointerdown',function(e){
    var r=document.createElement('span');r.className='ripple';
    var rect=b.getBoundingClientRect(),d=Math.max(rect.width,rect.height);
    r.style.width=r.style.height=d+'px';
    r.style.left=(e.clientX-rect.left-d/2)+'px';
    r.style.top=(e.clientY-rect.top-d/2)+'px';
    b.appendChild(r);setTimeout(function(){r.remove()},520);
  });
});

/* ---------- reveal ---------- */
var io=new IntersectionObserver(function(es){
  es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target)}});
},{threshold:.12});
document.querySelectorAll('.reveal').forEach(function(el){io.observe(el)});

/* ---------- shared data ---------- */
var DRIVERS=[
  {name:'MIKE', best:107842, col:'#7c5cff'},
  {name:'SARAH',best:108310, col:'#22d3ee'},
  {name:'J.T.', best:108977, col:'#e8b64c'},
  {name:'DIEGO',best:109455, col:'#2dd4a7'},
  {name:'ALEX', best:110221, col:'#4da3ff'}
];
function fmt(ms){if(!ms)return '--:--.---';var t=ms/1000,m=Math.floor(t/60),s=t-m*60;
  return m+':'+String(Math.floor(s)).padStart(2,'0')+'.'+String(Math.round((s%1)*1000)).padStart(3,'0')}
function initials(n){return n.replace(/[^A-Z]/g,'').slice(0,2)}

function boardRow(d,i,hidden){
  return '<div class="lb-row'+(i===0?' best':'')+(hidden?' hidden':'')+'">'+
    '<span class="pos">P'+(i+1)+'</span>'+
    '<span class="ava" style="background:'+d.col+'">'+initials(d.name)+'</span>'+
    '<span class="name">'+d.name+'</span>'+
    '<span class="time">'+fmt(d.best)+'</span></div>';
}

/* ---------- hero: live board + rolling clock ---------- */
var heroBoard=document.getElementById('heroBoard');
var heroFeed=document.getElementById('heroFeed');
var heroClock=document.getElementById('heroClock');
if(heroBoard){
  heroBoard.innerHTML=DRIVERS.slice(0,4).map(function(d,i){return boardRow(d,i,false)}).join('');
  heroFeed.innerHTML='<div class="lapline best"><span>Lap 1</span><span class="v">1:47.842</span></div>'+
                     '<div class="lapline"><span>Lap 2</span><span class="v">1:48.114</span></div>';
  if(!reduced){
    var t0=0;
    setInterval(function(){
      t0=(t0+137)%118000;
      heroClock.textContent=fmt(60000+t0%60000);
    },90);
  }
}

/* ---------- 3D pointer parallax ---------- */
function parallax(el, maxY, maxX){
  if(!el||reduced)return;
  var host=el.closest('.stage')||el.parentElement;
  host.addEventListener('pointermove',function(e){
    var r=host.getBoundingClientRect();
    var px=(e.clientX-r.left)/r.width-.5, py=(e.clientY-r.top)/r.height-.5;
    el.style.setProperty('--ry',(-15+px*maxY)+'deg');
    el.style.setProperty('--rx',(7-py*maxX)+'deg');
  });
  host.addEventListener('pointerleave',function(){
    el.style.setProperty('--ry','-15deg');el.style.setProperty('--rx','7deg');
  });
}
parallax(document.getElementById('heroDevice'),16,10);

/* ---------- scroll story ---------- */
var track=document.getElementById('storyTrack');
var stepsEls=document.querySelectorAll('#steps .step');
var screens=document.querySelectorAll('.story-stage .appscreen');
var storyDevice=document.getElementById('storyDevice');
var storyBoard=document.getElementById('storyBoard');
var storyBar=document.getElementById('storyBar');
var bulbs=document.querySelectorAll('#bulbs .bulb');
var goFlash=document.getElementById('goFlash');
var STEPS=6;
var lastStep=-1;

/* tall scroll area: one viewport per step */
if(track) track.style.height=(STEPS*70)+'vh';

/* story tiles */
var TRACKS=[['Monza','#3a6fd8'],['Spa','#2f9e6b'],['Imola','#d84a3a'],['Mugello','#8b5cf6'],['Silverstone','#e8b64c'],['Laguna Seca','#22d3ee']];
var CARS=[['Ferrari 488','#d40000'],['Huracán GT3','#59c30b'],['McLaren 650S','#ff8000'],['Audi R8 LMS','#c8ccd4'],['Porsche 911','#a5e34d'],['Mazda MX-5','#d43a3a']];
function trackArt(c){return '<svg viewBox="0 0 100 60"><path d="M14 44 C4 30 18 12 38 14 C58 16 62 34 78 32 C92 30 94 46 78 48 C58 50 34 58 14 44 Z" fill="none" stroke="'+c+'" stroke-width="5" stroke-linejoin="round"/></svg>'}
function carArt(c){return '<svg viewBox="0 0 140 52"><path d="M6 38 C14 28 28 24 44 23 L58 12 92 12 106 23 C120 24 130 29 134 35 L134 40 6 40 Z" fill="'+c+'" opacity=".92"/><circle cx="38" cy="40" r="8" fill="#0b1119" stroke="#3a4966" stroke-width="2"/><circle cx="104" cy="40" r="8" fill="#0b1119" stroke="#3a4966" stroke-width="2"/></svg>'}
var tg=document.getElementById('trackGrid'), cg=document.getElementById('carGrid');
if(tg) tg.innerHTML=TRACKS.map(function(t,i){return '<div class="tile'+(i===5?' sel':'')+'"><div class="art">'+trackArt(t[1])+'</div><div class="lbl">'+t[0]+'</div></div>'}).join('');
if(cg) cg.innerHTML=CARS.map(function(c,i){return '<div class="tile'+(i===0?' sel':'')+'"><div class="art">'+carArt(c[1])+'</div><div class="lbl">'+c[0]+'</div></div>'}).join('');
var dl=document.getElementById('drvList');
if(dl) dl.innerHTML=DRIVERS.slice(0,4).map(function(d,i){
  return '<div class="drv" data-i="'+i+'"><span class="ava" style="background:'+d.col+'">'+initials(d.name)+'</span><b>'+d.name+'</b><span class="tag">READY</span></div>'}).join('');

function paintBoard(n){
  if(!storyBoard)return;
  var shown=DRIVERS.slice(0,Math.max(0,n));
  storyBoard.innerHTML=shown.length
    ? shown.slice().sort(function(a,b){return a.best-b.best}).map(function(d,i){return boardRow(d,i,false)}).join('')
    : '<div class="lb-row hidden"></div>';
}

var stripEl=document.getElementById('steps');
/* on phones the steps are a sideways strip: keep the active card in view or the
   tablet shows the podium while the text still reads step one. scrollLeft is
   used on purpose (scrollIntoView would drag the page vertically too). */
function syncStrip(s){
  if(!stripEl||stripEl.scrollWidth<=stripEl.clientWidth+4)return;
  var el=stepsEls[s];
  if(!el)return;
  // snapped, not animated: the card must track the scroll position exactly, and
  // a pending smooth animation would fight the next step change
  stripEl.scrollLeft=Math.max(0,el.offsetLeft-(stripEl.clientWidth-el.offsetWidth)/2);
}

function setStep(s){
  if(s===lastStep)return;
  lastStep=s;
  stepsEls.forEach(function(el,i){el.classList.toggle('on',i===s)});
  syncStrip(s);
  screens.forEach(function(el){el.classList.toggle('on',parseInt(el.dataset.s,10)===s)});

  /* drivers appear one by one on step 3 */
  if(s===2){
    document.querySelectorAll('#drvList .drv').forEach(function(el,i){
      setTimeout(function(){el.classList.add('on')}, reduced?0:i*160);
    });
  } else if(s<2){
    document.querySelectorAll('#drvList .drv').forEach(function(el){el.classList.remove('on')});
  }

  /* start lights on step 4 */
  if(s===3){
    bulbs.forEach(function(b){b.classList.remove('on')});
    goFlash.classList.remove('on');
    bulbs.forEach(function(b,i){setTimeout(function(){b.classList.add('on')}, reduced?0:i*260)});
    setTimeout(function(){
      bulbs.forEach(function(b){b.classList.remove('on')});
      goFlash.classList.add('on');
    }, reduced?0:1700);
  }

  /* board fills as the night runs */
  paintBoard(s<4?0:(s===4?2:5));
}

function updateStory(){
  var r=track.getBoundingClientRect();
  var total=track.offsetHeight-window.innerHeight;
  var p=total>0?Math.min(1,Math.max(0,(-r.top)/total)):0;
  storyBar.style.width=(p*100)+'%';
  setStep(Math.min(STEPS-1,Math.floor(p*STEPS+0.0001)));
  if(storyDevice&&!reduced){
    storyDevice.style.setProperty('--ry',(-16+p*26)+'deg');
    storyDevice.style.setProperty('--rx',(9-p*7)+'deg');
  }
}
var ticking=false;
function onScroll(){
  if(!track||ticking)return;
  ticking=true;
  var run=function(){if(!ticking)return;ticking=false;updateStory()};
  requestAnimationFrame(run);
  // safety net: if rAF is throttled (hidden tab, some embedded views) the story
  // must never freeze on one step while the user keeps scrolling
  setTimeout(run,140);
}
window.addEventListener('scroll',onScroll,{passive:true});
window.addEventListener('resize',onScroll);
onScroll();
setStep(0);

/* rolling clock on the live step */
var storyClock=document.getElementById('storyClock');
if(storyClock&&!reduced){
  var c=41226;
  setInterval(function(){c=(c+91)%120000;storyClock.textContent=fmt(c)},90);
}

/* play device tilt */
parallax(document.getElementById('playDevice'),10,7);

/* ---------- demo frame ----------
   Shopify serves every storefront page with X-Frame-Options: DENY, so a plain
   iframe src is refused even same origin. Fetching the page and handing it to
   srcdoc is not a navigation, so it loads and keeps the demo sandboxed. */
(function(){
  var frame=document.querySelector('.playstage iframe');
  if(!frame)return;
  var url=frame.getAttribute('data-src');
  if(!url)return;
  var started=false;
  var load=function(){
    if(started)return;
    started=true;
    fetch(url,{credentials:'same-origin'})
      .then(function(r){if(!r.ok)throw new Error(r.status);return r.text()})
      .then(function(html){frame.srcdoc=html})
      .catch(function(){
        var cap=document.querySelector('.playcap');
        if(cap)cap.textContent='THE DEMO COULD NOT LOAD HERE. USE THE FULL SCREEN BUTTON BELOW.';
      });
  };
  // load when it comes into view, but never let the demo depend on the observer
  // firing: some embedded views throttle it and the frame would stay blank
  if('IntersectionObserver' in window){
    var once=new IntersectionObserver(function(es){
      es.forEach(function(en){if(en.isIntersecting){once.disconnect();load()}});
    },{rootMargin:'600px'});
    once.observe(frame);
  }
  setTimeout(load,2500);
})();

/* ---------- founding meter (paid slots, not the email list) ---------- */
fetch('https://app.afterlap.us/api/public/founding').then(function(r){return r.ok?r.json():null}).then(function(f){
  if(!f||typeof f.remaining!=='number')throw new Error('no count');
  document.getElementById('meterCount').textContent=f.remaining;
  setTimeout(function(){document.getElementById('meterFill').style.width=(f.taken/f.total*100)+'%'},300);
}).catch(function(){
  var m=document.querySelector('.founding-meter');if(m)m.style.display='none';
});


})();